import RangeSlider from 'core/rangeSlider';
import React from 'react';
import { FormField } from 'ui/formField';
import { spacing } from 'ui/theme';

// type Props = {
//   /** Callback function when value is changed. */
//   onChange: () => void,
//   /** Values of the number range */
//   value: [],
// };

export default class NumberRange extends React.Component {
  static defaultProps = {
    value: [
      { color: '#eb144c', value: 0 },
      { color: '#fcb900', value: 50 },
      { color: '#00d034', value: 100 },
    ],
  };

  constructor(props) {
    super(props);
    const { value } = props;
    const { min, max } = this.getMinMax(value);

    this.state = {
      min,
      max,
    };
  }

  /**
   * getMinMax
   * The first and last values are the min and max values.
   * @param { Array } values: The array of range values.
   * @returns { Object } The min and max values in an object { min, max }.
   */
  getMinMax = (values) => {
    const minObj = values[0];
    const maxObj = values[values.length - 1];

    return {
      min: minObj.value,
      max: maxObj.value,
    };
  };

  /**
   * handleChange
   * Callback function when values change.
   * @param { Object } e: The change event.
   * @param { Object } value: Array of updated values.
   * @returns { void }
   */
  handleChange = (e, value) => {
    const { onChange } = this.props;
    onChange(e, { value });
  };

  /**
   * handleChangeMin
   * Callback function when min value changes.
   * @param { Object } e: The change event.
   * @param { Number } min: Updated min value.
   * @returns { void }
   */
  handleChangeMin = (e, min) => {
    this.setState({ min });
  };

  /**
   * handleChangeMax
   * Callback function when max value changes.
   * @param { Object } e: The change event.
   * @param { Number } max: Updated max value.
   * @returns { void }
   */
  handleChangeMax = (e, max) => {
    this.setState({ max });
  };

  render() {
    const { value } = this.props;
    const { min, max } = this.state;

    return (
      <div style={{ width: 'calc(100% - 16px)', marginLeft: spacing.base }}>
        <FormField>
          <RangeSlider
            min={min}
            max={max}
            onChange={this.handleChange}
            onChangeMin={this.handleChangeMin}
            onChangeMax={this.handleChangeMax}
            value={value}
          />
        </FormField>
      </div>
    );
  }
}
